import { Service, Description } from '@dgx-pr-spa/shared/util';
import { createSelector } from '@ngrx/store';
import { ExtrasState } from '../reducers/extras.reducer';
import { getAdditionalServicesState } from './state.selector';

export const getExtrasState = createSelector(
  getAdditionalServicesState,
  (state) => state?.extras as ExtrasState
);

export const getExtras = createSelector(
  getExtrasState,
  (extras: ExtrasState) => extras?.data || ([] as Service[])
);

export const getExtrasLoading = createSelector(
  getExtrasState,
  (extras: ExtrasState) => extras?.loading
);

export const getExtrasLoaded = createSelector(
  getExtrasState,
  (extras: ExtrasState) => extras?.loaded
);

export const isInstallationSelected = createSelector(
  getExtras,
  (extras: Service[]) =>
    !!extras.filter((extra) => extra.description === Description.Installation)
      .length
);

export const isDisposalSelected = createSelector(
  getExtras,
  (extras: Service[]) =>
    !!extras.filter((extra) => extra.description === Description.Disposal)
      .length
);

export const isDeliverySelected = createSelector(
  getExtras,
  (extras: Service[]) =>
    !!extras.filter((extra) => extra.description === Description.Delivery)
      .length
);
